module.exports = __webpack_public_path__ + "static/img/qrcode.fc7721c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/qrcode.jpg
// module id = MSja
// module chunks = 1